import PropTypes from 'prop-types';
import React from 'react';
import {
  ControlLabel,
  FormControl,
  FormGroup,
  HelpBlock,
} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import './DatePickerAdapter.css';

class FormControlWrapper extends React.Component {
  focus = () => this.input.focus();

  render() {
    return (
      <FormControl
        {...this.props}
        autoComplete="off"
        inputRef={(ref) => {
          this.input = ref;
        }}
      />
    );
  }
}

const DatePickerAdapter = ({
  input: { value, isErrorField, ...inputRest },
  meta,
  id,
  label,
  ...rest
}) => {
  const hasError =
    (meta.touched || isErrorField) && (meta.error || meta.submitError);

  return (
    <FormGroup controlId={id} validationState={hasError ? 'error' : null}>
      <ControlLabel>{label}</ControlLabel>
      <DatePicker
        {...inputRest}
        selected={value}
        dateFormat="M/D/YY"
        customInput={<FormControlWrapper />}
        {...rest}
      />
      {hasError && <HelpBlock>{meta.error || meta.submitError}</HelpBlock>}
    </FormGroup>
  );
};

DatePickerAdapter.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default DatePickerAdapter;
